import {
  RPCDocs,
  RPCs,
  useRPC,
  useRPCServerEventHandler,
} from '@therms/react-modules'

export function useCurrentOnDutyCounts() {
  const {call, data, isCalling} = useRPC<
    RPCDocs.Users.GetUsersList.v1.Args,
    RPCDocs.Users.GetUsersList.v1.Data
  >(RPCs.Users.GetUsersList.v1, {
    hasStatus: true,
    pagination: {
      limit: 0,
    },
  })

  useRPCServerEventHandler('UserStatusChanged', call)

  return {
    counts: data?.total,
    loading: isCalling,
    refresh: call,
  }
}
